import React from 'react';
import { Grid, Card, CardContent, Typography, Box  } from '@mui/material';

import Feature1 from '../images/managesales.png';
import Feature2 from '../images/manageinventory.jpg';
import Feature3 from '../images/managecustomer.jpg';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';  

const Features = () => {
  const cards = [
    { title: 'Manage Sales', description: "Track every transaction in real time with detailed reporting and easy checkout flows. Accept multiple payment methods and streamline your sales process with speed and accuracy.",image : Feature1 },
    { title: 'Manage Inventory', description: "Stay in control of your stock with real-time inventory tracking, low-stock alerts, and automatic updates. Whether you have one location or many, always know what’s selling and what needs restocking.",image : Feature2 },
    { title: 'Manage Customers', description: "Build stronger customer relationships with smart CRM tools. Capture customer data, track purchase history, and offer personalized discounts or loyalty rewards to keep them coming back.",image : Feature3 },
  ];

  return (
    <Box sx={{ flexGrow: 1, px:{ xs: '20px', md: '100px' } ,mt:'50px' }}>
       <Grid container spacing={{ xs: 3, md: 8 }} >
        {cards.map((card, index) => (
          <Grid key={index} item xs={12} md={4}>
           <Card sx={{ '&:hover': {
              backgroundColor: 'tomato',
              color:'#fff'
            },backgroundColor: '#ffffff', borderRadius: 6, boxShadow: 3, height: '100%' }}>
              <CardContent sx={{px:{ xs: '20px', md: '50px' }, py:{ xs: '20px', md: '50px' }}}>
                <Box
                  component="img"
                  src={card.image}
                  alt="Slide"
                  sx={{
                    width: '100%',
                    maxWidth:'fit-content',
                    height: 200,
                    objectFit: 'cover',
                    borderRadius: 2,
                    mb: 2,
                    
                    
                  }}
                />
                <Typography variant="h6" component="div" gutterBottom>
                  {card.title}
                </Typography>
                <Typography variant="p" color="text.secondary">
                  {card.description}
                </Typography>
                <a className='links' href='tel:+917666349957'><Typography>Know more  </Typography><ArrowRightAltIcon></ArrowRightAltIcon></a>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      
    </Box>
  );
};

export default Features;
